import { render, staticRenderFns } from "./taskDetail.vue?vue&type=template&id=50eff290&scoped=true&"
import script from "./taskDetail.vue?vue&type=script&lang=tsx&"
export * from "./taskDetail.vue?vue&type=script&lang=tsx&"
import style0 from "./taskDetail.vue?vue&type=style&index=0&id=50eff290&style=less&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50eff290",
  null
  
)

export default component.exports